<script setup lang="ts">
import getMeta from "~/classes/getMeta"
import {EVENTS, type IScheduledEvent} from "~/data/events";
import {isDone} from "~/functions/isDone";
import EventPageHeader from "~/components/partials/EventPageHeader.vue";
import {useEventDateLeft} from "~/computed/useEventDateLeft";
import SpeakerKv from "~/components/speaker-kv.vue";

definePageMeta({
  layout: "default",
  name: "20250408-oracle-migration",
});

const EVENT_ID = 7;
const scheduledEvent : IScheduledEvent = EVENTS.find(i => i.id === EVENT_ID) as unknown as IScheduledEvent;

const title = scheduledEvent.title;
const description = scheduledEvent.description || '';
const share  = scheduledEvent.share || '/share.jpg?v=01';
useHead(getMeta(title, description, share));

useJsonld({
  "@context": "https://schema.org",
  "@type": "Event",
  "image": "https://conf.xsquare.ru"+share,
  "name": title,
  "description": description,
  "url": "https://conf.xsquare.ru"+scheduledEvent.url,
  "startDate": scheduledEvent.dateStart,
  "endDate": scheduledEvent.dateEnd,
  "offers": {
    "@type": "Offer",
    "description": "Зарегистрироваться",
    "url": scheduledEvent.regLink,
    "price": "0 руб."
  }
})

const isEventDone = computed(() => isDone(scheduledEvent));
</script>

<template>
  <div class="solution-page">
    <EventPageHeader
      :title="title"
      :description="description"
      :scheduled-event="scheduledEvent"
    />

    <div class="container event-page-content">
      <h2 class="h1">Программа вебинара</h2>
      <ul class="list list--numbers">
        <li>Презентация XSQUARE 5 версии платформы;</li>
        <li><span style="background: #93ff93;padding:.1em .2em">Oracle Apex на PostgresSQL на стероидах Visual Studio Code</span>;</li>
        <li>Разработка приложений с применением только SQL / plpgSQL;</li>
        <li>Разработка в <span style="background: #ffed93;padding:.1em .2em">xRAD 5.3</span> до <span style="background: #ff9393;padding:.1em .2em">5 раз</span> быстрее Apex/Forms, до <span style="background: #ff9393;padding:.1em .2em">3 раз</span> быстрее <span style="background: #ffed93;padding:.1em .2em">xRAD 5.1</span>;</li>
        <li>Горизонтальное масштабирование сервера приложений XSQUARE – PGHS на уровне ядра;</li>
        <li>Пару слов об xDac for Postgres. Презентация  XQUARE – DAC for <span style="color: #ea2e2e">Oracle</span>.</li>
      </ul>

      <br>
      <h2 class="h1">Кому точно будет интересно</h2>
      <ul class="list list--bullet">
        <li>Разработчикам Oracle Apex / Oracle Forms / Oracle DB / MS Access;</li>
        <li>Разработчикам PostgreSQL;</li>
        <li>Техническим архитекторам/директорам.</li>
      </ul>

      <br>
      <p style="font-weight: 400;font-size: 1.2em;;">
        <icon name="icon-100" style="width: 1.5em;height: 1.5em;vertical-align: middle;margin-right: .4em;"/>
        Обещаем <span style="text-decoration: underline">технический вебинар,</span> <span class="bold">без слайдов</span> и <span class="bold">маркетинга</span>
      </p>
      <br>

      <div class="space-3"></div>
      <h2 class="h1">Спикеры</h2>
      <ul class="speakers">
        <speaker-kv />
      </ul>

      <div class="space-2"></div>
      <h2 class="h1">Материалы к вебинару</h2>
      <ul class="list">
        <li><a href="https://xsquare.ru" target="_blank" class="link">Сайт XSQUARE</a></li>
        <li><a href="/docs/20250408-oracle-migration/XSQUARE_5_0_v1.pdf" class="link">Презентация</a></li>
        <li><a href="https://rutube.ru/channel/29913911/" class="link" target="_blank">Канал XSQUARE на RUTUBE</a></li>
      </ul>
    </div>

    <sprites :use-current-color="false">
      <symbol id="icon-100" viewBox="0 0 36 36" class="ignore"><path fill="rgb(255, 100, 100)" d="M1.728 21c-.617 0-.953-.256-1.127-.471c-.171-.211-.348-.585-.225-1.165L3.104 6.658l-1.714.097h-.013c-.517 0-.892-.168-1.127-.459a1.144 1.144 0 0 1-.221-.98c.15-.702.883-1.286 1.667-1.329l4.008-.227a3.42 3.42 0 0 1 .217-.008c.147 0 .536 0 .783.306c.252.312.167.709.139.839L3.719 19.454c-.187.884-.919 1.489-1.866 1.542L1.728 21zm10.743-2c-1.439 0-2.635-.539-3.459-1.559c-1.163-1.439-1.467-3.651-.878-6.397c1.032-4.812 4.208-8.186 7.902-8.395c1.59-.089 2.906.452 3.793 1.549c1.163 1.439 1.467 3.651.878 6.397c-1.032 4.81-4.208 8.184-7.904 8.394a4.66 4.66 0 0 1-.332.011zm3.414-13.746l-.137.004c-1.94.111-3.555 2.304-4.32 5.866c-.478 2.228-.381 3.899.272 4.707c.297.368.717.555 1.249.555l.14-.004c1.94-.109 3.554-2.301 4.318-5.864c.478-2.228.382-3.9-.27-4.708c-.296-.369-.718-.556-1.252-.556zm11.591 12.107c-1.439 0-2.637-.539-3.462-1.56c-1.163-1.439-1.467-3.651-.878-6.397c1.033-4.813 4.209-8.186 7.903-8.394c1.603-.09 2.903.453 3.79 1.549c1.163 1.439 1.467 3.651.878 6.396c-1.031 4.809-4.206 8.183-7.902 8.396c-.112.008-.221.01-.329.01zm3.411-13.747l-.136.004c-1.941.111-3.556 2.304-4.32 5.865c-.478 2.229-.381 3.901.272 4.708c.297.368.719.555 1.251.555l.14-.004c1.939-.109 3.554-2.302 4.318-5.864c.479-2.227.383-3.899-.27-4.707c-.298-.37-.72-.557-1.255-.557zM11 35.001a2.001 2.001 0 0 1-.703-3.874c.337-.126 8.399-3.108 20.536-4.12a2 2 0 0 1 .332 3.986c-11.59.966-19.386 3.851-19.464 3.88c-.23.086-.468.128-.701.128zM2.001 29a2 2 0 0 1-.719-3.866c.542-.209 13.516-5.126 32.612-6.131a1.987 1.987 0 0 1 2.103 1.892a2 2 0 0 1-1.892 2.103c-18.423.97-31.261 5.821-31.389 5.87a2.017 2.017 0 0 1-.715.132z"></path></symbol>
    </sprites>
  </div>
</template>
